export default ".row-pointer {\n  cursor: pointer;\n}\nh4{\n  border-bottom: 3px solid #ff7528;\n  padding-bottom: 1em;\n  padding-top: 1em;\n}\n";